import React from "react";
import { useState } from "react";
import { Box } from "@mui/material";
import styled from "styled-components";
import { LockOutlined } from "@mui/icons-material";
import TooltipIconButton from "components/TooltipIconButton";

const TeamInfo = styled.div`
  margin-bottom: 2rem;

  h2 {
    font-family: Roboto;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    color: #e5e5e5;
    margin-bottom: 13px;
  }

  .header-box {
    border-top: 1px solid #a0a0a0;
    border-bottom: 1px solid #a0a0a0;

    .email-column,
    .role-column {
      font-family: Roboto;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      color: #c4c4c4;
    }

    svg {
      font-size: 1.4rem !important;
    }

    .actions {
      margin-right: 10px;
    }
  }

  .member-item {
    font-family: Roboto;
    font-weight: 400;
    font-size: 9px;
    line-height: 11px;
    color: #c4c4c4;
    border-bottom: 1px solid #a0a0a0;

    .actions {
      margin-right: 15px;
      display: flex;
      align-items: center;
      padding-left: 3px;

      input:checked + label:after {
        top: 2px;
      }
    }
  }
`;

const LockedHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 13px;

  h2 {
    font-family: Roboto;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    color: #e5e5e5;
    margin: 0;
  }

  button {
    margin-left: 5px;
  }

  svg {
    font-size: 18px !important;
  }
`;

const TeamProfile = (props) => {
  const [isLocked, setIsLocked] = useState(false);
  
  return (
    <div>
      {isLocked ? 
      <LockedHeader>
        <h2>{props && props.teams[0]?.team}</h2>
        <TooltipIconButton title="Starter, Professional or Enterprise" ariaLabel="unlock-starter" placement="right" size={34} onClick={() => setIsLocked(false)}>
          <LockOutlined fontSize="medium" />
        </TooltipIconButton>
      </LockedHeader>
      : 
      (props.teams && props.teams[0] ?
      <TeamInfo>
        <h2>{props.teams[0].name}</h2>
        <Box display="flex" alignItems="center" justifyContent="space-between" className="header-box" padding="9px 7px">
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <div className="email-column">Email</div>
          </Box>
        </Box>
        {props.members && props.members.map((member, index) => (
            <Box display="flex" alignItems="center" justifyContent="space-between" className="member-item" padding="9px 7px" key={index}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <div className="email-column">{member.email}</div>
              </Box>
            </Box>
          ))}
      </TeamInfo> 
      : 
      null)}
    </div >
  );
};

export default TeamProfile;